import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ImportQueueListQuery } from '@upme/contracts';

// Use `.catch()` to swallow malformed URLs (e.g. legacy bookmarks) while
// still applying Zod defaults via `ImportQueueListQuery.parse({})`.
// Pass-through is required so the inferred SEARCH type stays in sync with
// the contract — TanStack Router infers it from `validateSearch`'s return.
export const Route = createFileRoute('/_authenticated/import-queue')({
  staticData: { breadcrumb: 'Очередь импорта' },
  validateSearch: ImportQueueListQuery.catch(ImportQueueListQuery.parse({})),
  component: () => <Outlet />,
});
